$(document).ready(function() {
    //Header Location Widget
    var DTL_Pincode = window.sessionStorage.getItem("DTL_pin");
    if (DTL_Pincode) {
        $('.h_location #usr_location').html(DTL_Pincode);
        $('.mob_location p').html('Delivering to '+DTL_Pincode);
        $('.h_location #usr_location, .mob_location p').attr('data-location', DTL_Pincode);
    } else {
        window.sessionStorage.setItem("DTL_pin", '560034');
        $('.h_location #usr_location').html('560034');
        $('.h_location #usr_location, .mob_location p').attr('data-location', '560034');

        $('.mob_location p').html('Delivering to 560034');
    }
    $('.h_location_withoutuser').click(function() {
        $('.pop_loc_outer').toggle();
        $('.loc_popup').show();
    })
    $('.h_location_user').click(function() {
        $('.pop_loc_outer').toggle();
        $('.loc_popup_after').show();
    })
    $('.loc_form button').click(function() {
        $('.loc_error').show();
        var LOC_zip_code = $('.loc_form input').val(); //110033
        var reg = /^[0-9]+$/;
        if (LOC_zip_code == '') {
            errorMessage = "*Zipcode required!";
            $('.loc_error').text(errorMessage);
        } else if ((LOC_zip_code.length) < 6 || (LOC_zip_code.length) > 6) {
            errorMessage = "*zipcode should only be 6 digits";
            $('.loc_error').text(errorMessage);
        } else if (!reg.test(LOC_zip_code)) {
            errorMessage = "*zipcode should be numbers only";
            $('.loc_error').text(errorMessage);
        } else {
            window.sessionStorage.setItem("DTL_pin", LOC_zip_code);
            $('.mob_location p').html('Delivering to '+LOC_zip_code);
            $('.h_location #usr_location').html(LOC_zip_code);
            $('.h_location #usr_location, .mob_location p').attr('data-location', LOC_zip_code);
            checkAvailability();
            errorMessage = "Pin code added";
            setTimeout(function() {
                location.reload();// new code 
            }, 500);
            $('.loc_error').css('color', '#333333');
            $('.loc_error').text(errorMessage);
            setTimeout(function() {
                $('.loc_error').hide();
                $('.pop_loc_outer').hide();
                $('.loc_popup').hide();
                //$('.loc_popup_after').hide();
                $('.loc_form input').val('');
            }, 2000);
        }
    })
    $('.pop_over_lay, .loc_cross').click(function() {
        $('.pop_loc_outer').hide();
        $('.loc_popup').hide();
        $('.loc_popup_after').hide();
    })
    $('.loc_pin').click(function() {
        $('.loc_popup_after').hide();
        $('.loc_popup').show();
    })
    $("#kp-account3").click(function() {
        $('.loc_popup').hide();
        $('.loc_popup_after').show();
    })
    $('.loc_addresses').click(function() {
        var adsZip = $(this).attr('data-zip');
        $('.loc_addresses').removeClass('loc_r_active');
        $(this).addClass('loc_r_active');
        window.sessionStorage.setItem("DTL_pin", adsZip);
        $('.h_location #usr_location, .mob_location p').html(adsZip);
        $('.mob_location p').html('Delivering to '+adsZip);
        $('.h_location #usr_location, .mob_location p').attr('data-location', adsZip);
        checkAvailability();
        setTimeout(function() {
            $('.pop_loc_outer').hide();
            $('.loc_popup_after').hide();
            location.reload();// new code 
        }, 1500);
    }) 
//Header Location Widget Ends
})

function checkAvailability() {
    const value = sessionStorage.getItem('DTL_pin');
    //const value = $.trim($pincodeInput.val());
    const isValid = /^[0-9]{6}$/.test(value);
    if (isValid){
        $.ajax({
            url: `https://apiprod.headsupfortails.com/v1/pinCodesAPI?input=${value}`,
            method: 'GET',
            success: function(response) {
                if (response.code === 200 && response.data && response.data.state) {
                    const state = response.data.state;
                    if (state === 'Karnataka' || state === 'Maharashtra') {
                            window.sessionStorage.setItem("HUFTPharmacy", 'Yes');
                            $(".MNV_PharmacyNav").show();
                            $(".MNV_HuftHubNav").hide();
                    } else {
                            window.sessionStorage.setItem("HUFTPharmacy", 'No');
                            $(".MNV_PharmacyNav").hide();
                            $(".MNV_HuftHubNav").show();
                    }
                }
            }
        });
    }
}